/**
 * Exposes values to the actStatusLabel directive used by the view template markup
 */
export class StatusLabelController {
  public status: string;
  public iconOnly: boolean;
}